import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_ENDPOINT || 'http://localhost:3002';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    'Authorization': token ? `Bearer ${token}` : '',
  };
};

export const getTransactions = async (params) => {
  try {
    const url = `${API_BASE_URL}/daos/${params.daoId}/transactions`;
    const response = await axios.get(url, {
      headers: getAuthHeaders(),
      params: {
        limit: params.limit,
        page: params.page,
        chain: params.chain,
        status: params.status,
        buyerWallet: params.buyerWallet,
        solutionName: params.solutionName
      }
    });
    return response;
  } catch (error) {
    console.error('Error fetching DAO transactions:', error);
    throw error;
  }
}; 